export default "__VITE_ASSET__CUyvCvWY__"